import { combineReducers, applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import axios from 'axios';

import organizations from './organizations';
import events from './events';
import me from './me';
import ui from './ui';
import membership from './membership';
import businessMetrics from './businessMetrics';
import users from './users';
import catalog_pages from './catalogPages';
import homepageAds from './homepageAds';

const { REACT_APP_API_URL } = process.env;

const makeStore = () => {
  const rootReducer = combineReducers({
    organizations,
    events,
    me,
    ui,
    membership,
    businessMetrics,
    users,
    catalog_pages,
    homepageAds
  });
  return createStore(rootReducer, applyMiddleware(thunk));
};

const request = axios.create({
  baseURL: REACT_APP_API_URL,
  withCredentials: true
});

export { makeStore, request };



// WEBPACK FOOTER //
// ./src/redux/index.js